import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import EnvCtx from '../contexts/EnvCtx';

export default function Favicon() {
    const { faviconCamera } = useContext(EnvCtx);

    return (
        <Helmet>
            <link
                rel="icon"
                type="image/png"
                href={faviconCamera || '/favicon.ico'}
            />
        </Helmet>
    );
}

